import { render } from "./Word.vue?vue&type=template&id=963b66a8&scoped=true"
import script from "./Word.vue?vue&type=script&lang=js"
export * from "./Word.vue?vue&type=script&lang=js"

import "./Word.vue?vue&type=style&index=0&id=963b66a8&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-963b66a8"

export default script